import { defineMessages } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
import { useFormatMessage } from 'src/providers/intl'
import { deleteSavedSearch } from 'src/actions/savedSearches'
import { selectCustomerId } from 'src/store/selectors/customerProfile'
import { selectFilter } from 'src/store/selectors/filters'
import { SavedSearchAlertModal } from '../../SavedSearchAlertModal'
import { SavedSearchAlertModalHeader } from '../../SavedSearchAlertModal/SavedSearchAlertModalHeader'
import { SavedSearchAlertModalBodySection } from '../../SavedSearchAlertModal/SavedSearchAlertModalBodySection'
import { SavedSearchAlertModalFooterButtons } from '../../SavedSearchAlertModal/SavedSearchAlertModalFooterButtons'

export const ALERT_MSG = defineMessages({
  header: {
    id: 'HomeSearch.listings.alerts.modal.remove.header',
    defaultMessage: 'Do you want to remove your current alert for {title}?',
  },
  body: {
    id: 'HomeSearch.listings.alert.modal.remove.body',
    defaultMessage:
      'By removing the alert, you will stop getting emails about new listings matching this search.',
  },
  primaryBtn: {
    id: 'HomeSearch.listings.alerts.modal.remove',
    defaultMessage: 'Remove alert',
  },
  secondaryBtn: {
    id: 'HomeSearch.listings.alerts.modal.keep',
    defaultMessage: 'Keep alert',
  },
})

export interface RemoveAlertModalProps {
  hideAlert: () => void
}

export const RemoveAlertModal = ({ hideAlert }: RemoveAlertModalProps) => {
  const dispatch = useDispatch()
  const intlFormat = useFormatMessage()
  const customerId = useSelector(selectCustomerId)
  const filters = useSelector(selectFilter)

  const removeAlert = () => {
    dispatch(deleteSavedSearch(customerId, filters.location.id))
    hideAlert()
  }

  return (
    <SavedSearchAlertModal hideAlertModal={hideAlert}>
      <SavedSearchAlertModalHeader
        headerMsg={intlFormat(ALERT_MSG.header, {
          title: filters.location.name,
        })}
      />
      <SavedSearchAlertModalBodySection bodyMsg={intlFormat(ALERT_MSG.body)} />
      <SavedSearchAlertModalFooterButtons
        primaryButtonMessage={intlFormat(ALERT_MSG.primaryBtn)}
        secondaryButtonMessage={intlFormat(ALERT_MSG.secondaryBtn)}
        handlePrimaryClick={removeAlert}
        isDestructiveAlert={true}
        handleClose={hideAlert}
      />
    </SavedSearchAlertModal>
  )
}
